import React, { useContext, useEffect, useState } from "react";
import { Form, Checkbox } from "antd";
import { neurologicalExaminationOptions } from "../../Options/clinicalImpressionOptions";
import DynamicInputFields from "../../../../blocks/FormItems/DynamicInputFields";

const NeurologicalSystem = ({ context, form }) => {
  const { formData } = useContext(context);
  const neurologicalData =
    formData?.clinical_diagnosis?.neurological_examination ||
    formData?.neurological_examination;
  const [showNeurologicalOthers, setShowNeurologicalOthers] = useState(
    neurologicalData?.includes("others")
  );
  const handleNeurologicalExaminationChange = (selectedOptions) => {
    setShowNeurologicalOthers(selectedOptions?.includes("others"));
  };

  useEffect(() => {
    setShowNeurologicalOthers(neurologicalData?.includes("others"));
  }, [formData]);

  return (
    <>
      <Form.Item
        label="Neurological Examination"
        name="neurological_examination"
      >
        <Checkbox.Group
          className="clinical-impression-checkbox-grid"
          onChange={handleNeurologicalExaminationChange}
        >
          {neurologicalExaminationOptions.map((option) => (
            <div key={option.value}>
              <Checkbox value={option.value}>{option.label}</Checkbox>
            </div>
          ))}
        </Checkbox.Group>
      </Form.Item>
      {showNeurologicalOthers && (
        <DynamicInputFields
          field_key={"neurological_examination_others"}
          form={form}
          inputStyle={{ maxWidth: 800 }}
        />
      )}
    </>
  );
};

export default NeurologicalSystem;
